import { render, staticRenderFns } from "./AtiSUInfo.vue?vue&type=template&id=464a1120&scoped=true"
import script from "./AtiSUInfo.vue?vue&type=script&lang=ts"
export * from "./AtiSUInfo.vue?vue&type=script&lang=ts"
import style0 from "./AtiSUInfo.vue?vue&type=style&index=0&id=464a1120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a1120",
  null
  
)

export default component.exports